module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre4",
    attrs: {
      "id": "pgepubid00050"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "page35"
    }
  }), _c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "pgepubid00051",
      "title": "p. 35"
    }
  }), _vm._v("YOUNG PENNYMORE.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Of")]), _vm._v(" the half-dozen men of Mid-Argyll condemned on one account or another for their part in the Rebellion, the last, and the least deserving of so scurvy a fate, was young John Clerk of Pennymore. He had been out in the affair more for the fun of the thing than from any high passion of politics; he would have fought as readily for the Duke as for the Young Pretender if the Duke had appealed to him first; he was a likeable lad to all who knew him, and the apple of his mother’s eye.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("The hanging of young John Clerk seemed at the time all the more harsh a measure since he was not charged directly with rebellion, but with being actor or art and "), _c('a', {
    attrs: {
      "id": "page36"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00052",
      "title": "p. 36"
    }
  }), _vm._v("part in the death of the Captain of Clonary, who was shot on his way from Culloden by a gang of lurking Jacobites of whom the lad was one, and maybe innocent. The murderers scattered to the mist and to the sea. For six years Clerk sequestered in the land of France, and was caught at last in a tender filial hour when he had ventured home to see his folk. A squad of the Campbells found him skulking in the wood of Pennymore on the very afternoon of his return; he had not even had the time to see his people, and the trinkets and sweetmeats he had meant for his mother were strewn from his pockets among the bracken as he was being dragged before the Lords.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("They looked at him—these dour and exigent gentlemen—with eyes that held no pity, not men at all for the nonce, but bowelless, inexorable legal mechanism; and Elchies, squeaking like a showman at a fair, sentenced him to the gallows.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“John Clerk,” he said, “you have had an "), _c('a', {
    attrs: {
      "id": "page37"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00053",
      "title": "p. 37"
    }
  }), _vm._v("impartial trial; you have been defended by an able advocate, who has made the most of a wretched cause; the jury has found you guilty as libelled, and it only rests with this court to pronounce sentence accordingly. You may yet, during the brief period you have to live, best serve your country and your friends by warning them against those pernicious principles which have brought you to this untimely end, and may the Lord have mercy on your soul!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("Then the doomster declared doom—that young John Clerk be handed over to the Sheriff-Depute, hanged by the neck on the burgh gibbet at Creag-nan-caoraich on the 5th September, and thereafter left for a time in chains.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("The lad made a bow to his judges, gave a last quick, eager glance about the court to assure himself his parents were not there, and then he was hurried down the trap-door to the cells.")]), _vm._v(" "), _c('p', {
    staticClass: "c"
  }, [_vm._v("* * * * *")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00054",
      "title": "p. 38"
    }
  }), _vm._v("There was still a month to go before the day of execution, and the Clerks of Pennymore—the proud and bitter dame and her pious husband—scoured the shire in search of sympathetic gentlemen of influence, and forswore sleep itself in their efforts to secure reprieve. They seemed, poor souls! miraculous in their great endurance, singly or together tramping here and there on a quest no neighbour dared to share, tragic to see upon the highway, horrible to hear at midnight when their cart went rumbling through the sleeping clachans. Sympathy was plentiful, but influence was shy, and the hopes of Pennymore were narrowed at last to Campbell of Lochgair, a lawyer himself, with the ear of His Grace and the Crown authorities.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("Lochgair, more, as it strangely seemed, for the sake of the peevish dame than for her husband’s, promised his active interest, and almost guaranteed release, and in the latter days of August went to Edinburgh "), _c('a', {
    attrs: {
      "id": "page39"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00055",
      "title": "p. 39"
    }
  }), _vm._v("to wait on the Lord Advocate, who was Prestongrange. It was the year of the stunted corn—1752—and never in the memory of man had been such inclement weather. The seas would seem to have forgotten the ways of peace; the glens were flooded, and the Highlands for a space were cut off from the Lowland world, and in a dreary privacy of storm. So the days passed—for most folk as if Time itself were bogged among the mire—for the man and wife in Pennymore as the flap of wings. They longed each evening for the morrow since it might bring welcome news, and yet they grudged the night and looked with terror on the dawn, since it brought the horrid hour a vigil closer.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("And there were no tidings from Lochgair!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“I might have known! I might have known!—a traitor ever, like his clan!” cried the mother, all her patience drained to the bitter dregs, wringing her hands till the blood came to the knuckles. “Lochgair "), _c('a', {
    attrs: {
      "id": "page40"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00056",
      "title": "p. 40"
    }
  }), _vm._v("will see the laddie hanged, and never jee his beaver. Too well I know his promises! We’re here forgot, the pair of us, and all the world sleeping sound, no way put about at the thought of young John Clerk. Deserted of men! deserted of men!” and her cry rose like a dirge in their lonely dwelling.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“But not of God and His grace,” said her husband, shrinking before the fury of her eye. “I have trusted Lochgair in this with all my heart, and he cannot betray us. He knows that his breath is all that lies between our laddie and eternity.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Oh, trust!” she hissed. “I ken the man; but I have trusted too, this fortnight, till my very heart is rent, yet God Himself cannot put off the 5th September.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Yea, even that, if it be His will; our times are in His hands,” said the pious husband, and turned him again to his Bible. But the woman’s doubts were "), _c('a', {
    attrs: {
      "id": "page41"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00057",
      "title": "p. 41"
    }
  }), _vm._v("justified, and on the morning of the day before their son should perish, they yoked the horse and drove in the cart to the burgh town to see him for the first time in the cell he had shared with some doomed sheep-stealers.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("Six miles lay between their home and the tolbooth gates, and yet it was in pitch-black night they came to the confines of the burgh, for they dreaded the pitying eyes of men and women. And all the way the woman fondled something in her plaid. They saw, afar, and few, and melancholy, wan lights in the burgh lands, blurred by the weeping rain; and at this spectacle—which told them the world went on its ordinary way and thought of breakfast, while their lad sat counting the hours, and they were engaged with misery—the man put his hand on the woman’s shoulder with a grip of steel, and she gave the last sob that was ever heard from her. For ever after she was a woman made of stone. "), _c('a', {
    attrs: {
      "id": "page42"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00058",
      "title": "p. 42"
    }
  }), _vm._v("The horse, as if it shared their feeling, stopped on the highway, reared itself in terror of something unseen, and snapped its belly-band, and the cart stood still under heaving beeches whose windy branches filled the dark with noise and cried down the very waves which roared on Creag-nan-caoraich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("The man jumped from the cart and fumbled with the harness, to find that further progress, wanting a girth, was not to be contemplated.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“I will walk into the town,” he said, “and get a rope, if you sit here till I return. You will not mind my leaving you, Margaret?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Mind!” she exclaimed with bitterness; “I have learned my lesson, and there is no more to mind.” But she fondled the thing concealed in her plaid, and her man walked quickly towards the wan lights of the tenements, leaving her all alone.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "id": "page43"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00059",
      "title": "p. 43"
    }
  }), _vm._v("For a moment only she heard his footsteps, the sound of them soon lost in the din of nature—the uproar of the forest trees, whose ponderous branches creaked; the wind, canorous, blowing between the mountains; the booming crepitation of the sea upon the rocks. And yet no sense of solitude depressed her, for her mind was occupied by one triumphant thought—that young John Clerk should at least be spared the horror and shame of a public execution.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("She had drawn, at first, the drenched plaid over her head to shield her and shut her in from the noise of tempest; but her hands in a little while were so busily engaged with her secret possession that the tartan screen at last rolled back on her shoulders, and she was aware of another sound than those of nature—the near, faint clang of chains. It was scarcely audible, but unmistakable—the beat of a loose end "), _c('a', {
    attrs: {
      "id": "page44"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00060",
      "title": "p. 44"
    }
  }), _vm._v("of iron links against wood, somewhere above her head, as she sat in the cart by the side of Creag-nan-caoraich. She stared up into the darkness and saw nothing, then stood to her feet and felt above her with trembling hand.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("Her fingers searched along a beam with a rope attached to it, whose meaning flooded to her brain with a gush that stunned; she touched a dead man’s feet! and the pitiless clouds that had swept all night across the heavens heaved for a moment from the face of the reeling moon, and she saw the wretch upon the gibbet!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“My son! my son!” she screamed till the rocks and trees gave back the echo, and yet the distant lights of the burgh town glowed on with unconcern.")]), _vm._v(" "), _c('p', {
    staticClass: "c"
  }, [_vm._v("* * * * *")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("Her cries had ceased; she was sunk in a listless torpor in the bottom of the cart when her man returned in a state as wretched "), _c('a', {
    attrs: {
      "id": "page45"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00061",
      "title": "p. 45"
    }
  }), _vm._v("as her own, running with stumbling feet along the rutted highway.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“My God! my God!” said he, “I have learned of something dreadful!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“I have learned it for myself,” said his wife. “You’re a day behind the fair.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Not one day, but eleven of them,” said her husband, hardly taking her meaning. “It is the fifteenth of September, and I’m so fearful of the worst. I dared not rap at a door in the town and ask.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“The fifteenth of September,” she repeated dully; “we have not slept so sound this month back that we could miss a fortnight. Have you lost your reason?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“I have seen a placard put up on the mercat cross,” said her husband, with his brow upon the horse’s back. “I read it in the light of the tolbooth windows, and it tells that the Government have decreed that, the day after September 2nd should be September 14th. Eleven days are dropped; it is called—it "), _c('a', {
    attrs: {
      "id": "page46"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00062",
      "title": "p. 46"
    }
  }), _vm._v("is called the Gregorian Calendar, and I have forgotten about the rope.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("The woman harshly laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Are you hearing me, Margaret?” he cried, putting up his arms to seize her, feeling some fresh terror.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Gregorian here, Gregorian there!” she exclaimed. “Whose Calendar but the cursed Campbells’, who have bonnily diddled me of my son! Our times are in God’s hands, you said; you are witness now they are in the devil’s!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“But it may be I was right, and that this is our Father’s miracle; John could not be—could not die but on the day appointed, and no such day, it seems, was on the Calendar. But I dared not ask, I dared not ask; I was dumfounded and ran to you, and here I am even without the rope.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("Again the woman harshly laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“You need not fash about the rope, good-man,” said she; “at your very hand is "), _c('a', {
    attrs: {
      "id": "page47"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00063",
      "title": "p. 47"
    }
  }), _vm._v("plenty for your purpose, for there my son is, young John Clerk, and he hangs upon the tree.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("The woman would not put a hand upon the body. Without her aid her husband lowered the burden from the gibbet, laid it in the cart and covered it with his plaid; and when a girth for the horse had been improvised from a part of the shameful halter, the two of them turned for home, walking side by side through the dawn that now was coming, slow and ashen, to the east.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("The man was dumb, and walked without volition, wrestling with satanic doubts of a Holy Purpose that had robbed him of his son with such unnecessary and ghastly mockery; the woman cuddled her cold secret in her bosom, stared glassily at the coming day, and for a time let fury and despair whirl through her brain like poison vapours.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“I will never rest,” she cried at last, “till Lochgair has paid the penalty for this "), _c('a', {
    attrs: {
      "id": "page48"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00064",
      "title": "p. 48"
    }
  }), _vm._v("trick upon us. My laddie’s death is at his door!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("Her man said nothing, leading the horse.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“At his door!” she cried more vehemently. “Are you hearing me? He has slain my son in this shameful way as surely as if he had tied the rope himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("Her husband made no answer; he found in her words but the thought of one for the time demented, and he walked appalled at the chaos into which the precious edifice of his faith had tumbled. Rudely she plucked his arm and screamed in his ear—")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“What will you do to Campbell?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“To Campbell?” he repeated vaguely. “God forgive him his false hopes and negligence, but it was not he who condemned our son.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“But for him,” said the woman, “my son would have died like a gentleman, and not like a common thief.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“I do not understand,” said her husband blankly.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "id": "page49"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00065",
      "title": "p. 49"
    }
  }), _vm._v("“No, you never understand,” she sneered, “that was ever your failing. Do you think that if I had not the promise of Lochgair, I should let my laddie die upon the gallows? The first of his race! the first of his race! I had brought with me his pistol that he might save himself the scandal of the doomster’s hand,” and she took the weapon from her bosom.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("Her husband looked at it, grasped at once the Spartan spirit of her scheme, and swithered between chagrin that it had been foiled, and shame that the sin of self-slaughter should for a moment seem desirable.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Oh, Margaret!” he cried, “you terrify me. Throw that dreadful weapon in the sea,” and he made to take it from her, but she restored it to her plaid.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“No, no,” she cried, “there may be use for it—”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Use for it!” he repeated, and she poured into his ear the torrent of her hatred of Lochgair. “He could have won my laddie "), _c('a', {
    attrs: {
      "id": "page50"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00066",
      "title": "p. 50"
    }
  }), _vm._v("off,” she said; “we had his own assurance. And if we had not put our trust in him, we would have gone to others—Asknish or Stonefield, or the Duke himself—the Duke would have had some pity on a mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Lochgair may have sore deceived us,” said her husband, “yet he was but an instrument; our laddie’s doom was a thing appointed from the start of Time.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Then from the start of Time you were doomed to slay Lochgair.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“What! I?” quo’ he,")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“One or other of us. We are, it seems by your religion, all in the hands of fate and cannot help ourselves. Stand up like a man to this filthy Campbell, and give him the bullet that was meant for a better man.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“You are mad, goodwife,” said her husband; “I would shed no man’s blood.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“I speak not of men,” said she, “but of that false fiend Lochgair who has kept us on the rack, and robbed Time itself of a fortnight to make his clan diversion. Oh, man! man! "), _c('a', {
    attrs: {
      "id": "page51"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00067",
      "title": "p. 51"
    }
  }), _vm._v("are you a coward? Challenge him to the moor; remember that at the worst my son who lies in the cart there could have died in decency and not at the doomster’s hand if Lochgair had not misled us—”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Woman!” cried her husband, “get behind me!” and took refuge in a gust of mumbled prayer.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("They were now upon the Kenmore shore where the sea came deep against the rocks; no living soul had met them on their passage down the coast with their disgraceful burden, and alarmed at the prospect of encounter with any curious wayfarer, they drew the cart behind a thicket, to let an approaching horseman pass without his observation. Far off they heard the clatter of his horse’s hoofs, and while yet he was a good way distant the questing eye of the woman saw he wore a beaver hat, and a familiar coat with silver buttons!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Look! look!” she cried, “here comes the very man, delivered to our hands.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "id": "page52"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00068",
      "title": "p. 52"
    }
  }), _vm._v("“I will not touch him! I will not touch him!” said her husband, cowering behind the bushes.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Then will I!” said she, and drew the pistol from her breast, and her husband wrestled with her for the weapon.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("Lochgair in a furious haste came galloping, his vision engaged on the road before him, and would have swept on his way unnoticing the cart, its burden, or attendants, but for the altercation in the thicket. He checked his horse, turned round on the saddle, and peered among the branches, where the husband, breathing hard, had got possession of the weapon.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“He has slain my son, but I will spare him,” said the husband, and the woman put her mouth against his ear.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“No son of yours,” she whispered, “that is the curse of it!—but his own!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“My God!” cried her husband, and fired at the horseman’s breast. He fell like a "), _c('a', {
    attrs: {
      "id": "page53"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00069",
      "title": "p. 53"
    }
  }), _vm._v("sack of oats on the roadway, and his horse flew off among the brackens.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("For a while the world seemed in a swound. In a swound the waves lapped up against the rocks; in a swound the leafage moved; in a swound the sea-birds cried, and the man and woman, desperate, sought to hide the evidence of their crime. They turned the dead man over on his back, emptied his pouches, filled his clothes with stones, then threw him, with the pistol, in the sea.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Home! home!” the wife commanded, placing the dead man’s papers in her plaid, and she walked, without remorse, by the side of her whimpering man, to Pennymore. She stirred the embers of the fire, and one by one destroyed the dead man’s documents, until the very last, and that she glanced at horror-stricken, for it was her son’s reprieve!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("With a scream she rushed outside and turned her husband’s plaid from the face of the dead man in the cart—and it was not young John Clerk!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0